import React, { useState } from 'react';
import { Tabs } from 'antd';
import { LineChartOutlined, TrophyOutlined, AimOutlined, BarChartOutlined } from '@ant-design/icons';
import PageHeader from '../../../components/shared/PageHeader';

// Import components
import ExecutiveSummary from './components/ExecutiveSummary';
import TrendAnalysis from './components/TrendAnalysis';
import GoalTracking from './components/GoalTracking';

const PerformanceReports: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('summary');

  const tabItems = [
    {
      key: 'summary',
      label: (
        <span>
          <TrophyOutlined />
          Executive Summary
        </span>
      ),
      children: <ExecutiveSummary />,
    },
    {
      key: 'trends',
      label: (
        <span>
          <LineChartOutlined />
          Trend Analysis
        </span>
      ),
      children: <TrendAnalysis />,
    },
    {
      key: 'goals',
      label: (
        <span>
          <AimOutlined />
          Goal Tracking
        </span>
      ),
      children: <GoalTracking />,
    },
  ];

  return (
    <div>
      <PageHeader
        icon={<BarChartOutlined />}
        title="Performance Reports"
        subtitle="Comprehensive business performance analysis, trend tracking, and goal monitoring"
      />

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="card"
        items={tabItems}
      />
    </div>
  );
};

export default PerformanceReports; 